import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const AddUser = (props) => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [name, setName] = useState(
    props.mode === "edit" ? props.userEdit.name : ""
  );
  const [mail, setMail] = useState(
    props.mode === "edit" ? props.userEdit.mail : ""
  );
  const [phone, setPhone] = useState(
    props.mode === "edit" ? props.userEdit.phone : ""
  );
  const [brandsArr, setBrandsArr] = useState(
    props.mode === "edit" ? props.userEdit.brands.split(",") : []
  );
  const [password, setPassword] = useState(
    props.mode === "edit" ? props.userEdit.password : ""
  );
  const [split, setSplit] = useState(
    props.mode === "edit" ? +props.userEdit.split : 0
  );
  const [role, setRole] = useState(
    props.mode === "edit" ? props.userEdit.role : "user"
  );
  const [company, setCompany] = useState(
    props.mode === "edit" ? props.userEdit.companies : props.companies[0].name
  );
  const [edit, setEdit] = useState(props.mode === "edit" ? false : true);
  const [actualSource, setActualSource] = useState(props.sources[0].name);

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getUsersList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchUsers();
  };

  useEffect(() => {
    getData();
  }, []);

  const validate = () => {
    if (!name || !mail || !phone || !password) {
      return false;
    } else {
      return true;
    }
  };

  const fetchAddUser = async () => {
    var body = {
      name: name,
      mail: mail,
      phone: phone,
      password: password,
      brands: generateBrand(),
      role: role,
      split: split,
      company: company,
    };

    await fetch("https://apisellcrm.ftpeople.pl/addUser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Użytkownik",
          text: "dodany",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const addUser = () => {
    if (validate()) {
      fetchAddUser();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const generateBrand = () => {
    if (brandsArr.length === 0) {
      return "";
    } else {
      var ret = "";
      brandsArr.map((brand, index) => {
        ret = ret + (index === 0 ? "" : ",") + brand;
      });
      return ret;
    }
  };

  const fetchEditUser = async () => {
    var body = {
      id: props.userEdit.id,
      name: name,
      mail: mail,
      phone: phone,
      password: password,
      brands: generateBrand(),
      split: split,
      role: role,
      company: company,
    };

    await fetch("https://apisellcrm.ftpeople.pl/editUser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Użytkownik",
          text: "zmieniony",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const editUser = () => {
    if (validate()) {
      fetchEditUser();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const fetchDeleteUser = async (newUser) => {
    var body = { id: props.userEdit.id, newUser: newUser };

    await fetch("https://apisellcrm.ftpeople.pl/deleteUser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Użytkownik",
          text: "usunięty",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const fetchFreeLeads = async (newUser) => {
    var body = { id: props.userEdit.id, status: newUser };

    await fetch("https://apisellcrm.ftpeople.pl/freeLeads", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Leady",
          text: "zwolnione",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const deleteUser = (e) => {
    var model = [];
    users
      .filter(
        (el) =>
          el.name !== props.userEdit.name &&
          el.companies.trim() === props.userEdit.companies.trim()
      )
      .map((user) => {
        model[user.id] = user.name;
      });

    MySwal.fire({
      title: "Na kogo przepisać leady?",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        fetchDeleteUser(result.value);
      }
    });
  };

  const freeLeads = (e) => {
    var model = [];
    props.statuses.map((user) => {
      model[user.name] = user.name;
    });

    MySwal.fire({
      title: "Jaki status uwolnić z przypisań?",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        fetchFreeLeads(result.value);
      }
    });
  };

  const endEditMode = (e) => {
    setEdit(false);
    setName(props.userEdit.name);
    setMail(props.userEdit.mail);
    setPhone(props.userEdit.phone);
    setPassword(props.userEdit.password);
    setBrandsArr(props.userEdit.brands.split(","));
    setSplit(props.userEdit.split);
    setRole(props.userEdit.role);
  };

  const handleBrandAdd = (e) => {
    setLoading(true);
    if (brandsArr.filter((brand) => brand === actualSource).length > 0) {
      setLoading(false);
    } else {
      brandsArr.push(actualSource);
      setTimeout(function () {
        setLoading(false);
      }, 1);
    }
  };

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
          zIndex: "2",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                {edit
                  ? props.mode === "edit"
                    ? "EDYTUJ UŻYTKOWNIKA"
                    : "DODAJ UŻYTKOWNIKA"
                  : "UŻYTKOWNIK"}
                <br />
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  nazwa <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </div>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  adres e-mail <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={mail}
                  onChange={(e) => {
                    setMail(e.target.value);
                  }}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  numer telefonu <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                />
              </div>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  hasło <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  marki <span style={{ color: "red" }}>*</span>
                </p>
                <select
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={actualSource}
                  onChange={(e) => {
                    setActualSource(e.target.value);
                  }}
                >
                  {props.sources.map((el) => (
                    <option value={el.name}>{el.name}</option>
                  ))}
                </select>
                <button
                  className="loginButtonLogin"
                  id={"statusNote"}
                  value={0}
                  style={{
                    margin: "0",
                    backgroundColor: !edit ? "gray" : "navy",
                    borderColor: !edit ? "gray" : "navy",
                    width: "45%",
                    fontSize: ".6vw",
                    padding: "5px 5px",
                    marginTop: "10px",
                  }}
                  onClick={handleBrandAdd}
                  disabled={!edit}
                >
                  dodaj
                </button>
                <div style={{ marginTop: "20px", width: "100%" }}>
                  {brandsArr.map((brand) => (
                    <>
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "70%" }}>{brand}</div>
                        <div style={{ width: "30%" }}>
                          <button
                            className="loginButtonLogin"
                            id={"statusNote"}
                            value={brand}
                            disabled={!edit}
                            style={{
                              margin: "0",
                              backgroundColor: !edit ? "gray" : "navy",
                              borderColor: !edit ? "gray" : "navy",
                              width: "45%",
                              fontSize: ".6vw",
                              padding: "5px 5px",
                            }}
                            onClick={(e) => {
                              setBrandsArr(
                                brandsArr.filter(
                                  (brandX) => brandX !== e.target.value
                                )
                              );
                            }}
                          >
                            usuń
                          </button>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </div>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  rozdzielanie leadów <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="checkbox"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  checked={+split === 1 ? true : false}
                  onChange={(e) => {
                    e.target.checked === false ? setSplit(0) : setSplit(1);
                  }}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  rola <span style={{ color: "red" }}>*</span>
                </p>
                <select
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={role}
                  onChange={(e) => {
                    setRole(e.target.value);
                  }}
                >
                  <option value={"user"}>{"Użytkownik"}</option>
                  <option value={"admin"}>{"Administrator"}</option>
                </select>
              </div>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  dział <span style={{ color: "red" }}>*</span>
                </p>
                <select
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={company}
                  onChange={(e) => {
                    setCompany(e.target.value);
                  }}
                >
                  {props.companies.map((company) => (
                    <option value={company.name}>{company.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div
              style={{
                marginTop: "50px",
                display: "flex",
                gap: "20px",
              }}
            >
              {edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      borderColor: "green",
                    }}
                    onClick={props.mode === "edit" ? editUser : addUser}
                  >
                    {props.mode === "edit" ? "EDYTUJ" : "DODAJ"} UŻYTKOWNIKA
                  </button>
                </>
              ) : (
                ""
              )}
              {props.mode === "edit" && !edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "navy",
                      borderColor: "navy",
                    }}
                    onClick={() => setEdit(true)}
                  >
                    TRYB EDYCJI
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" && edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      borderColor: "red",
                    }}
                    onClick={endEditMode}
                  >
                    ZAKOŃCZ TRYB EDYCJI
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      borderColor: "red",
                    }}
                    onClick={deleteUser}
                  >
                    USUŃ
                  </button>
                </>
              ) : (
                ""
              )}
              {props.mode === "edit" ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "orange",
                      borderColor: "orange",
                    }}
                    onClick={freeLeads}
                  >
                    ZWOLNIJ LEADY
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddUser;
